export default "__VITE_ASSET__BayIT3dO__"